import { styled, Button as BaseButton } from '@material-ui/core'
import AddCircleOutline from '@material-ui/icons/AddCircleOutline'

const BUTTON_HEIGHT = 32
const BUTTON_MIN_WIDTH = 140

export const Button = styled(BaseButton)(({ theme }) => ({
  height: BUTTON_HEIGHT,
  minWidth: BUTTON_MIN_WIDTH,
  '& span': {
    fontSize: 12,
    lineHeight: '14px',
    fontWeight: 'bold',
    textTransform: 'none',
  },
  '& svg:first-child': {
    fontSize: 24,
    '& > path:first-child': {
      fontSize: 24,
    },
  },
}))

export const AddIcon = styled(AddCircleOutline)(({ theme }) => ({
  color: theme.palette.primary.main,
  marginRight: theme.spacing(0.3),
}))
